import React from "react";

const InvoicePreview = ({ mainData, invoiceData, totals }) => {
    const inputRef = React.useRef(null);
    const [image, setImage] = React.useState(null);

    const handleDivClick = () => {
        inputRef.current.click();
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
        }
    };

    return (
        <div className="invoice" id="invoice-print-area">
            {mainData.theme === "Branded" ?
                <div>
                    <div className="invoice-header">
                        <div style={{ fontSize: "14px", textAlign: "left" }}>
                            <input placeholder="Brightline Studio Ltd." style={{ fontWeight: "bolder" }} /><br />
                            <input className="text-muted" placeholder="742 Evergreen Avenue, Suite 301" /><br />
                            <input className="text-muted" placeholder="San Francisco, CA 94107" /><br />
                            <input className="text-muted" placeholder="billing@brightlinestudio.com" /><br />
                        </div>
                        <div>
                            <input
                                type="file"
                                accept="image/*"
                                ref={inputRef}
                                style={{ display: "none" }}
                                onChange={handleImageUpload}
                            />
                            <div className="company-logo"
                                onClick={handleDivClick}
                                style={{
                                    width: "200px",
                                    height: "100px",
                                    border: "2px dashed #aaa",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    backgroundImage: image ? `url(${image})` : "none",
                                }}
                            >
                                {!image && <span>Click to upload image</span>}
                            </div>
                        </div>
                    </div>
                    <h1 align="right">INVOICE</h1>
                </div> :
                <div className="invoice-header">
                    <div>
                        <h1>INVOICE</h1>
                        <p className="fs-6 text-muted" align="left">#{mainData.invoice_number}</p>
                    </div>
                    <div className="company-info">
                        <input placeholder="Brightline Studio Ltd." style={{ fontWeight: "bolder" }} /><br />
                        <input className="text-muted" placeholder="742 Evergreen Avenue, Suite 301" /><br />
                        <input className="text-muted" placeholder="San Francisco, CA 94107" /><br />
                        <input className="text-muted" placeholder="billing@brightlinestudio.com" /><br />
                    </div>
                </div>
            }
            <div className="invoice-details">
                <div style={{ textAlign: "left" }}>
                    <strong>Billed To:</strong><br />
                    <input className="text-muted" placeholder="Janet Doe" /><br />
                    <input className="text-muted" placeholder="189 Westwood Drive" /><br />
                    <input className="text-muted" placeholder="Austin, TX 78745" /><br />
                </div>
                <div>
                    <table>
                        <tbody>
                            {mainData.theme === "Branded" && <tr align="right">
                                <td><strong>Invoice #:</strong></td>
                                <td>{mainData.invoice_number}</td>
                            </tr>
                            }
                            <tr align="right">
                                <td><strong>Invoice Date:</strong></td>
                                <td>{mainData.date}</td>
                            </tr>
                            <tr align="right">
                                <td><strong>Due Date:</strong></td>
                                <td>{mainData.due_date}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <table className="invoice-table">
                <thead>
                    <tr>
                        <th>Description</th>
                        <th>Qty</th>
                        <th>Price</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    {invoiceData.map((data, i) => (
                        <tr key={i}>
                            <td>{data.title}</td>
                            <td>{data.quantity}</td>
                            <td>{mainData.currency}{data.price}{data.unit && `/${data.unit}`}</td>
                            <td>{mainData.currency}{(data.price || 0) * (data.quantity || 0)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="invoice-summary">
                <div>
                    {mainData.terms && <div style={{ textAlign: "left" }} className="terms">
                        <h5>Terms and Conditions</h5>
                        <h6 className="text-muted">{mainData.terms}</h6>
                    </div>}
                </div>
                <div>
                    <table className="table table-sm">
                        <tbody>
                            <tr align="right">
                                <td align="right" colSpan={2}>Subtotal</td>
                                <td>{mainData.currency}{totals.subTotal}</td>
                            </tr>
                            <tr align="right">
                                <td align="right" colSpan={2}>Tax ({mainData.tax_rate}%)</td>
                                <td>{mainData.currency}{totals.tax}</td>
                            </tr>
                            <tr className="total" align="right">
                                <td align="right" colSpan={2}>Total</td>
                                <td>{mainData.currency}{totals.total}</td>
                            </tr>
                        </tbody>
                    </table>
                    {/* <p>Subtotal: <span>{mainData.currency}{totals.subTotal}</span></p>
                <p>Tax ({mainData.tax_rate}%): <span>{mainData.currency}{totals.tax}</span></p>
                <p className="total">Total: <span>{mainData.currency}{totals.total}</span></p> */}
                </div>
            </div>

            <div className="invoice-footer">
                {mainData.note}
            </div>
        </div>
    )
}

export default InvoicePreview;